<template>
    <div class="text-center">
        <v-bottom-sheet persistent v-model="sheetShown" inset scrollable>
            <!-- >>> Form, Fields -->
            <v-card>
                <v-card-text style="height:800px;margin-top:24px;">
                    <v-form v-model="valid" ref="form" lazy-validation>
                        <v-container>
                            <v-stepper v-model="formStepper" non-linear>
                                <!-- >>> Stepper Header -->
                                <v-stepper-header>
                                    <v-stepper-step
                                        editable
                                        step="1"
                                        :rules="[ () => isValid_Stepper1 ]"
                                        @click="() => onClick_StepperHeader('1')">
                                        General
                                    </v-stepper-step>

                                    <v-divider></v-divider>

                                    <v-stepper-step
                                        editable
                                        step="2"
                                        :rules="[ () => isValid_Stepper2 ]"
                                        @click="() => onClick_StepperHeader('2')">
                                        Contact
                                    </v-stepper-step>

                                    <v-divider></v-divider>

                                    <v-stepper-step
                                        editable
                                        step="3"
                                        :rules="[ () => isValid_Stepper3 ]"
                                        @click="() => onClick_StepperHeader('3')">
                                        Emerg. Contacts
                                    </v-stepper-step>

                                    <v-divider></v-divider>

                                    <v-stepper-step
                                        editable
                                        step="4"
                                        :rules="[ () => isValid_Stepper4 ]"
                                        @click="() => onClick_StepperHeader('4')">
                                        Contract
                                    </v-stepper-step>

                                    <v-divider></v-divider>

                                    <v-stepper-step
                                        editable
                                        step="5"
                                        :rules="[ () => isValid_Stepper5 ]"
                                        @click="() => onClick_StepperHeader('5')">
                                        Documentation
                                    </v-stepper-step>

                                    <v-divider v-if="editorMode === 'update'"></v-divider>

                                    <v-stepper-step
                                        v-if="editorMode === 'update'"
                                        editable
                                        step="6"
                                        @click="() => onClick_StepperHeader('6')">
                                        Base History
                                    </v-stepper-step>
                                </v-stepper-header>
                                <!-- <<< Stepper Header -->


                                <!-- >>> General -->
                                <v-stepper-content
                                    step="1"
                                    ref="stepperContent1">
                                    <!-- >>> Row - Personal Information -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Personal Information</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_FirstName"
                                                        name="input_FirstName"
                                                        :rules ="[
                                                            rules.req(input_FirstName),
                                                            rules.min(2, input_FirstName),
                                                            rules.max(50, input_FirstName)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            <p>
                                                            First Name <span style="color: red; font-size: 1.4rem;">*</span>
                                                            </p>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_LastName"
                                                        :rules ="[
                                                            rules.req(input_LastName),
                                                            rules.min(2, input_LastName),
                                                            rules.max(50, input_LastName)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Last Name <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-menu
                                                        ref="birthdateMenu"
                                                        v-model="birthdateMenu"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="formattedBirthdate"
                                                                :rules ="[
                                                                    rules.req(formattedBirthdate),
                                                                ]"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                clearable>
                                                                <template v-slot:label>
                                                                    Birthdate <span style="color: red; font-size: 1.4rem;">*</span>
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            ref="picker_Birthdate"
                                                            v-model="input_Birthdate"
                                                            :max="get_MaxDate_Birthdate()"
                                                            :min="get_MinDate_Birthdate()"
                                                            @change="onChange_SaveBirthdate">
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_Gender"

                                                        :rules ="[
                                                            rules.req(input_Gender),
                                                        ]"
                                                        :items="genderItems"
                                                        item-text="text"
                                                        item-value="value">
                                                        <template v-slot:label>
                                                            Sex <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_Nationality"

                                                        :rules ="[
                                                            rules.req(input_Nationality),
                                                        ]"
                                                        :items="get_Countries"
                                                        item-value="id"
                                                        item-text="name">
                                                        <template v-slot:label>
                                                            Nationality <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_MaritalStatus"

                                                        :rules ="[
                                                            rules.req(input_MaritalStatus),
                                                        ]"
                                                        :items="maritalStatusItems"
                                                        item-text="text"
                                                        item-value="value">
                                                        <template v-slot:label>
                                                            Marital Status <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_NoOfChildren"

                                                        :rules ="[
                                                            rules.req(input_NoOfChildren),
                                                            rules.max(2, input_NoOfChildren),
                                                            rules.onlyNumbers(input_NoOfChildren)
                                                        ]"
                                                        clearable
                                                        maxlength="2"
                                                        counter>
                                                        <template v-slot:label>
                                                            No. of Children <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_NoOfChildrenInSchool"
                                                        :rules ="[
                                                            rules.max(2, input_NoOfChildrenInSchool),
                                                            rules.onlyNumbers(input_NoOfChildrenInSchool),
                                                            rules.smallerThan(input_NoOfChildrenInSchool, input_NoOfChildren)
                                                        ]"
                                                        clearable
                                                        maxlength="2"
                                                        counter
                                                        label="No. of Children in School">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Personal Information -->

                                    <!-- >>> Row - Body Metrics -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Body Metrics</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_EyeColor"
                                                        :items="eyeColorItems"
                                                        label="Eye Color">
                                                    </v-select>
                                                </v-col>

                                                    <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_HeightInCm"
                                                        :rules="[
                                                            rules.max(3, input_HeightInCm),
                                                            rules.onlyNumbers(input_HeightInCm)
                                                        ]"
                                                        clearable
                                                        maxlength="3"
                                                        counter
                                                        label="Height in cm">
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_Shoesize"
                                                        :rules ="[
                                                            rules.max(2, input_Shoesize),
                                                            rules.onlyNumbers(input_Shoesize)
                                                        ]"
                                                        clearable
                                                        maxlength="2"
                                                        counter
                                                        label="Shoesize">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        style="margin-top: 14px;"
                                                        v-model="input_Overall"
                                                        :rules ="[
                                                            rules.max(5, input_Overall),
                                                            rules.onlyNumbers(input_Overall)
                                                        ]"
                                                        maxlength="5"
                                                        clearable
                                                        counter
                                                        label="Overall">
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="8">
                                                    <v-combobox
                                                        v-model="input_Languages"
                                                        :items="languagesItems"
                                                        label="Languages"
                                                        clearable
                                                        multiple
                                                        small-chips>
                                                    </v-combobox>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Body Metrics -->

                                    <!-- >>> Row - Passport Information -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Passport Information</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_Passport1No"
                                                        label="Passport 1 No"
                                                        clearable>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-menu
                                                        ref="passport1ValidUntilMenu"
                                                        v-model="passport1ValidUntilMenu"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="formatedPassport1ValidUntil"

                                                                :rules ="[
                                                                    rules.req(formatedPassport1ValidUntil),
                                                                ]"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                clearable>
                                                                <template v-slot:label>
                                                                    Passport 1 valid until <span style="color: red; font-size: 1.4rem;">*</span>
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            ref="picker_Passport1ValidUntil"
                                                            v-model="input_Passport1ValidUntil"
                                                            :max="get_MaxDate_Passport1ValidUntil()"
                                                            :min="get_MinDate_Passport1ValidUntil()"
                                                            @change="onChange_SavePassport1ValidUntil">
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_Passport2No"
                                                        label="Passport 2 No"
                                                        clearable>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-menu
                                                        ref="passport2ValidUntilMenu"
                                                        v-model="passport2ValidUntilMenu"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="formatedPassport2ValidUntil"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                clearable>
                                                                <template v-slot:label>
                                                                    Passport 2 valid until
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            ref="picker_Passport2ValidUntil"
                                                            v-model="input_Passport2ValidUntil"
                                                            :max="get_MaxDate_Passport2ValidUntil()"
                                                            :min="get_MinDate_Passport2ValidUntil()"
                                                            @change="onChange_SavePassport2ValidUntil">
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Passport Information -->
                                </v-stepper-content>
                                <!-- <<< General -->



                                <!-- >>> Contact -->
                                <v-stepper-content
                                    step="2"
                                    ref="stepperContent2">
                                    <!-- >>> Row - Address Information -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Address Information</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_City"

                                                        :rules ="[
                                                            rules.req(input_City),
                                                            rules.min(3, input_City),
                                                            rules.max(50, input_City),
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            City <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_ZIP"

                                                        :rules ="[
                                                            rules.req(input_ZIP),
                                                            rules.max(15, input_ZIP),
                                                            rules.min(3, input_ZIP),
                                                            rules.isZIP(input_ZIP)
                                                        ]"
                                                        maxlength="15"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Zipcode <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_Country"
                                                        :items="get_Countries"
                                                        item-value="id"
                                                        item-text="name"
                                                        label="Country">
                                                    </v-select>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="8">
                                                    <v-text-field
                                                        v-model="input_Street"

                                                        :rules ="[
                                                            rules.req(input_Street),
                                                            rules.max(50, input_Street),
                                                            rules.min(3, input_Street),
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Street <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_SteetNo"

                                                        :rules ="[
                                                            rules.req(input_SteetNo),
                                                            rules.max(5, input_SteetNo)
                                                        ]"
                                                        maxlength="5"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Street No <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Address Information -->

                                    <!-- >>> Row - Communication -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Communication</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_Phone1"

                                                        :rules ="[
                                                            rules.req(input_Phone1),
                                                            rules.max(50, input_Phone1),
                                                            rules.min(6, input_Phone1),
                                                            rules.isPhoneNumber(input_Phone1)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Phone <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_Phone2"
                                                        :rules ="[
                                                            rules.max(50, input_Phone2),
                                                            rules.min(6, input_Phone1),
                                                            rules.isPhoneNumber(input_Phone1)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Phone 2
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_Email"

                                                        :rules ="[
                                                            rules.req(input_Email),
                                                            rules.max(50, input_Email),
                                                            rules.min(6, input_Email),
                                                            rules.isEmailAddress(input_Email)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            E-Mail <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Communication -->
                                </v-stepper-content>
                                <!-- <<< Contact -->



                                <!-- >>> Em. Contacts -->
                                <v-stepper-content
                                    step="3"
                                    ref="stepperContent3">
                                    <!-- >>> Row - Emergency Contact 1 -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Emergency Contact 1</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_FirstNameEmergContact1"
                                                        :rules ="[
                                                            rules.max(50, input_FirstNameEmergContact1),
                                                            rules.min(2, input_FirstNameEmergContact1)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            First Name
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_LastNameEmergContact1"
                                                        :rules ="[
                                                            rules.max(50, input_LastNameEmergContact1),
                                                            rules.min(2, input_LastNameEmergContact1),
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Last Name
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_PhoneEmergContact1"
                                                        :rules ="[
                                                            rules.max(50, input_PhoneEmergContact1),
                                                            rules.min(6, input_PhoneEmergContact1),
                                                            rules.isPhoneNumber(input_PhoneEmergContact1)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Phone
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_EmailEmergContact1"
                                                        :rules ="[
                                                            rules.max(50, input_EmailEmergContact1),
                                                            rules.min(6, input_EmailEmergContact1),
                                                            rules.isEmailAddress(input_EmailEmergContact1)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            E-Mail
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_RelationEmergContact1"
                                                        :rules ="[
                                                            rules.max(50, input_RelationEmergContact1)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Relationship to Employee
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- >>> Row - Emergency Contact 1 -->

                                    <!-- >>> Row - Emergency Contact 2 -->
                                     <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Emergency Contact 2</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_FirstNameEmergContact2"
                                                        :rules ="[
                                                            rules.max(50, input_FirstNameEmergContact2),
                                                            rules.min(2, input_FirstNameEmergContact2)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            First Name
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_LastNameEmergContact2"
                                                        :rules ="[
                                                            rules.max(50, input_LastNameEmergContact2),
                                                            rules.min(2, input_LastNameEmergContact2),
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Last Name
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_PhoneEmergContact2"
                                                        :rules ="[
                                                            rules.max(50, input_PhoneEmergContact2),
                                                            rules.min(6, input_PhoneEmergContact2),
                                                            rules.isPhoneNumber(input_PhoneEmergContact2)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Phone
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_EmailEmergContact2"
                                                        :rules ="[
                                                            rules.max(50, input_EmailEmergContact2),
                                                            rules.min(6, input_EmailEmergContact2),
                                                            rules.isEmailAddress(input_EmailEmergContact2),
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            E-Mail
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_RelationEmergContact2"
                                                        :rules ="[
                                                            rules.max(50, input_RelationEmergContact2)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Relationship to Employee
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                     </v-row>
                                     <!-- <<< Row - Emergency Contact 2 -->
                                </v-stepper-content>
                                <!-- <<< Em. Contacts -->



                                <!-- >>> Contract -->
                                <v-stepper-content
                                    step="4"
                                    ref="stepperContent4">
                                    <!-- >>> Row - Sundair Details -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>{{ CONF_CLIENT }} Details</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_3LetterCode"

                                                        :rules ="[
                                                            rules.req(input_3LetterCode),
                                                            rules.min(3, input_3LetterCode),
                                                            rules.max(3, input_3LetterCode),
                                                            rules.onlyLetters(input_3LetterCode)
                                                        ]"
                                                        maxlength="3"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            3 Letter Code <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_invoiceOrder"

                                                        :rules ="[
                                                            rules.req(input_invoiceOrder),
                                                            rules.min(1, input_invoiceOrder),
                                                            rules.max(10, input_invoiceOrder),
                                                            rules.onlyNumbers(input_invoiceOrder)
                                                        ]"
                                                        maxlength="10"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Invoice Order <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_Function"
                                                        :rules ="[
                                                            rules.req(input_Function),
                                                        ]"
                                                        :items="functionItems"
                                                        item-text="text"
                                                        item-value="value">
                                                        <template v-slot:label>
                                                            Function <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_AdditionalFunction"
                                                        :items="additionalFunctionItems">
                                                        <template v-slot:label>
                                                            Additional Function
                                                        </template>
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_CockpitOrCabin"
                                                        :rules ="[
                                                            rules.req(input_CockpitOrCabin),
                                                        ]"
                                                        :items="cockpitOrCabinItems"
                                                        :disabled="editorMode==='create'">
                                                        <template v-slot:label>
                                                            Cockpit or Cabin <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_Base"
                                                        :rules ="[
                                                            rules.req(input_Base),
                                                        ]"
                                                        :items="get_Bases_Filtered"
                                                        item-text="aptCode"
                                                        item-value="idAirport"
                                                        :disabled="editorMode ==='update'">
                                                        <template v-slot:label>
                                                            Base <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_Aircraft"
                                                        :rules ="[
                                                            rules.req(input_Aircraft),
                                                        ]"
                                                        :items="get_AircraftConfigs"
                                                        item-text="code"
                                                        item-value="idAircraft">
                                                        <template v-slot:label>
                                                            Aircraft <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_FlyingOrOffice"

                                                        :rules ="[
                                                            rules.req(input_FlyingOrOffice),
                                                        ]"
                                                        :items="flyingOrOfficeItems"
                                                        item-text="text"
                                                        item-value="value">
                                                        <template v-slot:label>
                                                            Flying or Office <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <v-combobox
                                                        v-model="input_Crews"
                                                        :items="get_people_crewsOnAirplane"
                                                        :item-text="createNameForInputCrews"
                                                        item-value="id"
                                                        chips
                                                        multiple
                                                        label="Crews">
                                                    </v-combobox>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Sundair Details -->

                                    <!-- >>> Row - Contract Details -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Contract Details</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-menu
                                                        ref="contractStartsFromMenu"
                                                        v-model="contractStartsFromMenu"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="formattedContractStartsFrom"

                                                                :rules ="[
                                                                    rules.req(formattedContractStartsFrom),
                                                                    rules.notAfterContractEnds(input_ContractStartsFrom, input_ContractEndsOn)
                                                                ]"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                clearable>
                                                                <template v-slot:label>
                                                                    Contract starts from <span style="color: red; font-size: 1.4rem;">*</span>
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            ref="picker_ContractStartsFrom"
                                                            v-model="input_ContractStartsFrom"
                                                            :max="get_MaxDate_ContractStartsFrom()"
                                                            :min="get_MinDate_ContractStartsFrom()"
                                                            @change="onChange_SaveContractStartsFrom">
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-menu
                                                        ref="contractEndsOnMenu"
                                                        v-model="contractEndsOnMenu"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="formattedContractEndsOn"
                                                                :rules="[
                                                                    rules.notBeforeContractStarts(input_ContractEndsOn, input_ContractStartsFrom)
                                                                ]"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                clearable>
                                                                <template v-slot:label>
                                                                    Contract ends on
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            ref="picker_ContractEndsOn"
                                                            v-model="input_ContractEndsOn"
                                                            :max="get_MaxDate_ContractEndsOn()"
                                                            :min="get_MinDate_ContractEndsOn()"
                                                            @change="onChange_SaveContractEndsOn">
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_VacationDays"

                                                        :rules ="[
                                                            rules.req(input_VacationDays),
                                                            rules.max(2, input_VacationDays),
                                                            rules.onlyNumbers(input_VacationDays)
                                                        ]"
                                                        maxlength="2"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Vacation Days <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_OffdaysPerYear"
                                                        :rules ="[
                                                            rules.max(3, input_OffdaysPerYear),
                                                            rules.onlyNumbers(input_OffdaysPerYear)
                                                        ]"
                                                        maxlength="3"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Contractual Offdays per year
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_OffdaysPerMonth"
                                                        :rules ="[
                                                            rules.max(2, input_OffdaysPerMonth),
                                                            rules.onlyNumbers(input_OffdaysPerMonth)
                                                        ]"
                                                        maxlength="2"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Contractual Offdays per month
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <v-text-field
                                                        v-model="input_RadiationValue"
                                                        :rules ="[
                                                            rules.max(3, input_RadiationValue),
                                                            rules.onlyNumbers(input_RadiationValue)
                                                        ]"
                                                        maxlength="3"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            Radiation Value
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Contract Details -->

                                    <!-- >>> Row - Additional Details -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Additional Details</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <v-textarea
                                                        v-model="input_Remark"
                                                        :rules="[
                                                            rules.max(200, input_Remark)
                                                        ]"
                                                        name="input_Remark"
                                                        label="Remark"
                                                        auto-grow
                                                        maxlength="200"
                                                        counter
                                                        clearable
                                                        value="">
                                                    </v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Additional Details -->
                                </v-stepper-content>
                                <!-- <<< Contract -->



                                <!-- >>> Documentation-->
                                <v-stepper-content
                                    step="5"
                                    ref="stepperContent5">
                                    <!-- >>> Row - Additional Informations -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Additional Information</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_Experienced"
                                                        :rules ="[
                                                            rules.req(input_Experienced),
                                                        ]"
                                                        :items="experiencedItems"
                                                        clearable>
                                                        <template v-slot:label>
                                                            Experienced <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="12" sm="4">
                                                    <v-menu
                                                        ref="experiencedSinceMenu"
                                                        v-model="experiencedSinceMenu"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="formattedExperiencedSince"
                                                                :rules="[
                                                                    rules.reqIfExperienced(input_ExperiencedSince, input_Experienced)
                                                                ]"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                clearable>
                                                                <template v-slot:label>
                                                                    Experienced since
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            ref="picker_ExperiencedSince"
                                                            v-model="input_ExperiencedSince"
                                                            :max="get_MaxDate_ExperiencedSince()"
                                                            :min="get_MinDate_ExperiencedSince()"
                                                            @change="onChange_SaveExperiencedSince">
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_DrivingLicenseB"
                                                        :items="drivingLicenseBItems"
                                                        clearable>
                                                        <template v-slot:label>
                                                            Driving License Type B
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_Freelancer"
                                                        :items="freelancerItems"
                                                        clearable>
                                                        <template v-slot:label>
                                                            Freelancer
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_Active"
                                                        :items="activeItems"
                                                        clearable>
                                                        <template v-slot:label>
                                                            Active?
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Additional Informations -->
                                </v-stepper-content>
                                <!-- <<< Documentation-->



                                <!-- >>> Base History-->
                                <v-stepper-content
                                    v-if="editorMode === 'update'"
                                    step="6"
                                    ref="stepperContent6">

                                        <!-- >>> Row - New Base History -->
                                        <v-row class="input-row">
                                            <v-col cols="12" sm="4">
                                                <h2>New Base History</h2>
                                            </v-col>

                                            <v-col cols="12" sm="8">
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <v-menu
                                                            ref="basehistorySinceMenu"
                                                            v-model="basehistorySinceMenu"
                                                            :close-on-content-click="false"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="auto">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field
                                                                    v-model="formattedBasehistorySince"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    clearable
                                                                    ref="ref_BaseHistory_Since">
                                                                    <template v-slot:label>
                                                                        Base since <span style="color: red; font-size: 1.4rem;">*</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                ref="picker_BasehistorySince"
                                                                v-model="input_BasehistorySince"
                                                                :max="get_MaxDate_BasehistorySince()"
                                                                :min="get_MinDate_BasehistorySince()"
                                                                @change="onChange_SaveBasehistorySince">
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </v-col>

                                                    <v-col cols="12" sm="4">
                                                        <v-select
                                                            v-model="input_BaseHistoryAirport"
                                                            :items="get_Bases_Filtered"
                                                            item-text="aptCode"
                                                            item-value="idAirport"
                                                            ref="ref_BaseHistory_Airport">
                                                            <template v-slot:label>
                                                                Airport <span style="color: red; font-size: 1.4rem;">*</span>
                                                            </template>
                                                        </v-select>
                                                    </v-col>

                                                    <v-col cols="12" sm="2">
                                                        <v-btn
                                                        block
                                                            style="margin-top:16px;"
                                                            color="primary"
                                                            @click="onValidate_BaseHistory">
                                                            Add
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Row - New Base History -->

                                        <!-- >>> Row - List of Base History -->
                                        <v-row class="input-row">
                                            <v-col cols="12" sm="4">
                                                <h2>List of Base History</h2>
                                            </v-col>

                                            <v-col cols="12" sm="8">
                                                <v-data-table
                                                    style="margin-bottom: 35px;margin-top:24px;"
                                                    :headers="headers"
                                                    :items="input_contractBaseStationHistory"
                                                    :disable-pagination="true"
                                                    :hide-default-footer="true"
                                                    sort-by="sinceDate"
                                                    :sort-desc="true"
                                                    class="elevation-1 data-table-custom-colors">

                                                    <template v-slot:item.sinceDate="{ item }">
                                                        <p style="font-weight:300; margin: 0;">{{ item.sinceDate | dayjsUtcDe }}</p>
                                                    </template>

                                                    <!-- >>> Action:Column -->
                                                    <template v-slot:item.actions="{ item }">
                                                        <v-icon small @click="onClick_DeleteBasehistoryEntry(item)">
                                                            mdi-delete
                                                        </v-icon>
                                                    </template>
                                                    <!-- <<< Action:Column -->

                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Row - List of Base History -->
                                </v-stepper-content>
                                <!-- <<< Base History-->
                            </v-stepper>
                        </v-container>
                    </v-form>
                </v-card-text>


                <!-- >>> Action Buttons - Bottom -->
                <v-card-actions>
                    <p v-if="editorMode === 'update'" class="mb-0 ml-7 font-weight-medium">Current Resource: {{ actualResourceName }}</p>
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseSheet"> Close</v-btn>
                    <v-btn style="width:120px" depressed elevation="1" color="primary" @click="onValidate_Form" v-if="formStepper !== '6'"> Save</v-btn>
                </v-card-actions>
                <!-- <<< Action Buttons - Bottom -->
            </v-card>
            <!-- <<< Form, Fields -->
        </v-bottom-sheet>

        <!-- >>> Dialog: 'Confirm Delete'  -->
		<v-dialog v-model="showConfirmDeleteDialog" max-width="500px">
			<v-card>
				<v-card-title class="justify-center subtitle-1">Are you sure you want to delete this item?</v-card-title>
					<v-card-actions style="margin-top: 20px;">
						<v-spacer></v-spacer>
						<v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseDelete"> Cancel</v-btn>
						<v-btn style="width:120px" depressed elevation="1" color="primary" @click="onClick_DeleteItemConfirm"> OK</v-btn>
						<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <<< Dialog: 'Confirm Delete'  -->
    </div>
</template>

<script>
	import { CONF_CLIENT } from '../../../../../config';

    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';

    import { eventBus } from '../../../../../main';

    import dayjs from 'dayjs';
    import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
    import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
    dayjs.extend(isSameOrAfter);
    dayjs.extend(isSameOrBefore);


    export default {
        name: 'BottomSheet',

        /* >>> *************************************************************** / /* Props */
        props: {

            value : [Boolean], // 'showSheet'
            editorMode : String, // 'update', 'create'
            resourcePrefillObject : Object // item

		},
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
		data: function() {

			return {
                // >>> ------------------------------------ 'Form Validation Rules'
                valid : false,
                rules: {
                    req(v) {
                        return (v || '').toString().length > 0 || `Field is required`;
                    },

                    min(min, v) {
                        return (v === null || v === '' || v === undefined) || v.length >= min || `Length must be at least ${min}`;
                    },

                    max(max, v) {
                        return (v || '').length <= max || `Length may not be greater than ${max}.`;
                    },

                    onlyLetters(v) {
                        return (v === null || v === '' || v === undefined) || (/^[A-Za-z]+$/).test(v.toString()) || 'Only letters allowed.';
                    },

                    onlyNumbers(v) {
                        return (v === null || v === '' || v === undefined) || (/^[0-9]+$/).test(v.toString()) || 'Only numbers allowed.';
                    },

                    smallerThan(v, compare) {
                        return (v <= compare) || `Can not be higher than ${compare}`;
                    },

                    notBeforeContractStarts(v, compare) {
                        return (v === null || v === undefined || v === '') || (compare === null || compare === undefined || compare === '') || dayjs(v).isSameOrAfter(dayjs(compare)) || `Can not be before Contract Start.`;
                    },

                    notAfterContractEnds(v, compare) {
                        return (v === null || v === undefined || v === '') || (compare === null || compare === undefined || compare === '') || dayjs(v).isSameOrBefore(dayjs(compare)) || `Can not be after Contract End.`;
                    },

                    isPhoneNumber(v) {
                        return (v === null || v === '' || v === undefined) || (/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/).test(v.toString()) || 'Not a valid Phone number.';
                    },

                    isEmailAddress(v) {
                        return (v === null || v === '' || v === undefined) || (/^\S+@\S+$/).test(v.toString()) || 'Not a valid E-Mail Address.';
                    },

                    isZIP(v) {
                        return (v === null || v === '' || v === undefined) || (/^[a-z0-9][a-z0-9\- ]{0,13}[a-z0-9]$/i).test(v.toString()) || 'Not a valid ZIP-Code.';
                    },

                    reqIfExperienced(v, experienced) {
                        return experienced === 'false' || (v || '').toString().length > 0 || `Field is required`;
                    }
                },
                // >>> ------------------------------------ 'General'
                input_ResourceId: null,
                input_idHrDepartment: null,
                input_FirstName: '',
                input_LastName: '',
                input_Birthdate: '',
                genderItems: [
                    { text: 'MALE', value: 'M' },
                    { text: 'FEMALE', value:'F' }
                ],
                input_Gender: null,
                maritalStatusItems: ['MARRIED', 'SINGLE'],
                input_MaritalStatus: null,
                input_Nationality: 70,
                input_NoOfChildren: '',
                input_NoOfChildrenInSchool: '',
                flyingOrOfficeItems: [
                    { text: 'FLYING', value: 'F' },
                    { text: 'OFFICE', value: 'O' }
                ],
                input_FlyingOrOffice: null,
                eyeColorItems: ['BLUE', 'GREEN', 'BLACK', 'BROWN'],
                input_EyeColor: null,
                input_HeightInCm: '',
                input_Shoesize: '',
                input_Overall: '',
                languagesItems: ['English', 'German', 'Spanish', 'Russian', 'French', 'Greek'],
                input_Languages: '',
                input_Passport1No: '',
                input_Passport1ValidUntil: '',
                input_Passport2No: '',
                input_Passport2ValidUntil: '',
                input_Remark: '',
                // >>> ------------------------------------ 'Contact'
                input_City: '',
                input_ZIP: '',
                input_Country: 70,
                input_Street: '',
                input_SteetNo: '',
                input_Phone1: '',
                input_Phone2: '',
                input_Email: '',
                // >>> ------------------------------------ 'Emergency Contact'
                input_FirstNameEmergContact1: null,
                input_LastNameEmergContact1: null,
                input_PhoneEmergContact1: null,
                input_EmailEmergContact1: null,
                input_RelationEmergContact1: null,
                input_FirstNameEmergContact2: null,
                input_LastNameEmergContact2: null,
                input_PhoneEmergContact2: null,
                input_EmailEmergContact2: null,
                input_RelationEmergContact2: null,
                // >>> ------------------------------------ 'Contract Infos'
                input_3LetterCode: '',
                input_invoiceOrder: '',
                input_Function: null,
                functionItems: [
                    {text: 'Cabin Attendant', value: 'CA' },
                    {text: 'Captain', value: 'CP' },
                    {text: 'First Officer', value: 'FO' },
                    {text: 'Senior Cabin Crew Member', value: 'SCCM' }
                ],
                input_AdditionalFunction: null,
                additionalFunctionItems: [
                    'TRE-LR',
                    'TRE-L',
                    'TRI-LR',
                    'TRI-L',
                    'LCC-LR',
                    'LCC-L',
                    'LTC-LR',
                    'LTC-L',
                    'CPT-LR',
                    'CPT-L',
                    'CPTt-L',
                    'FO-R',
                    'FOt-R',
                    'CCS',
                    'CFS',
                    'X3',
                ],
                input_Base: null,
                input_CockpitOrCabin: null,
                cockpitOrCabinItems: [
                    { text: 'Cockpit', value: '12' },
                    { text: 'Cabin', value: '11' },
                ],
                input_Aircraft: null,
                input_ContractStartsFrom: '',
                input_ContractEndsOn: '',
                input_VacationDays: '',
                input_OffdaysPerYear: '',
                input_OffdaysPerMonth: '',
                input_RadiationValue: '',
                input_Crews: [],
                // >>> ------------------------------------ 'Documentation'
                input_Experienced: 'true',
                experiencedItems: [
                    { text: 'Yes', value: 'true' },
                    { text: 'No', value: 'false' },
                ],
                input_ExperiencedSince: '',
                input_DrivingLicenseB: 'true',
                drivingLicenseBItems: [
                    { text: 'Yes', value: 'true' },
                    { text: 'No', value: 'false' },
                ],
                input_Freelancer: 'false',
                freelancerItems: [
                    { text: 'Yes', value: 'true' },
                    { text: 'No', value: 'false' },
                ],
                input_Active: 'true',
                activeItems: [
                    { text: 'Yes', value: 'true' },
                    { text: 'No', value: 'false' },
                ],
                // >>> ------------------------------------ 'Base History'
                input_BasehistorySince: dayjs().format('YYYY-MM-DD'),
                input_BaseHistoryAirport: null,
                input_contractBaseStationHistory: [],
                // >>> ------------------------------------
                formStepper: 1,
                date: null,
                // >>> ------------------------------------ 'Menus'
                birthdateMenu: null,
                passport1ValidUntilMenu: null,
                passport2ValidUntilMenu: null,
                contractStartsFromMenu: null,
                contractEndsOnMenu: null,
                experiencedSinceMenu: null,
                basehistorySinceMenu: null,
                // >>> ------------------------------------
                showConfirmDeleteDialog: false,
                baseHistoryObjectToDelete: null,
                // >>> ------------------------------------ 'Base History Table'
				headers : [
                    { text: 'Since', value: 'sinceDate', class: 'sticky-header grey lighten-3' },
					{ text: 'Airport', value: 'baseCode', class: 'sticky-header grey lighten-3' },
					{ text: 'Actions', value: 'actions', class: 'sticky-header grey lighten-3' },
				],
                // >>> ------------------------------------ 'Stepper Errors'
                isValid_Stepper1: true,
                isValid_Stepper2: true,
                isValid_Stepper3: true,
                isValid_Stepper4: true,
                isValid_Stepper5: true,
                activeStepper: '1',
                // >>> ------------------------------------ 'Resource Name'
                actualResourceName: '',
                // >>> -------------------------- CONFIG
                CONF_CLIENT: CONF_CLIENT,
			};

		}, // eo funtion data()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
				'get_AircraftConfigs',
                'get_Countries',
                'get_Bases',
                'get_Bases_Filtered',
                'get_people_crewsOnAirplane'
			]),


			/*******************************************************************
			* sheetShown{}
			*
			* Desc:
			* Note:
			*
			*/
            sheetShown: {

				get() {

                    const me = this;
                    let eventRecord = me.resourcePrefillObject;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/sheetShown/get');
                    if (true === me.value) { // we're opening so initialize data

                        // >>> ------------------ reset validation
                        if(this.$refs.form !== undefined) {
                            this.$refs.form.resetValidation();
                        }

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                this.onAssign_Update(eventRecord);
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            this.onAssign_Create();
                        }

                    }

                    return this.value;

                }, // eo function sheetShown get()

				set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/sheetShown/set');
                    me.formStepper = 1;
                    this.$emit('input', value);

                }, // eo function sheetShown set()

            }, // eo sheetShown{}


			/******************************************************************* 'DateFields Formatter'
			* formattedBirthdate{}
			*
			* Desc:
			* Note:
			*
			*/
            formattedBirthdate: {

                get() {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/formattedBirthdate/get');
                    return this.input_Birthdate ? this.formatDateForTextField(this.input_Birthdate) : '';

                }, // eo function formattedBirthdate get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/formattedBirthdate/set');
                    return this.input_Birthdate = value;

                }, // eo function formattedBirthdate set()

            }, // eo formattedBirthdate{}





			/******************************************************************* STILL NEEDED CHANGES HERE!!!!
			* formatedPassport1ValidUntil{}
			*
			* Desc:
			* Note:
			*
			*/
            formatedPassport1ValidUntil: {

                get() {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/formatedPassport1ValidUntil/get');
                    return this.input_Passport1ValidUntil ? this.formatDateForTextField(this.input_Passport1ValidUntil) : '';

                }, // eo function formatedPassport1ValidUntil get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/formatedPassport1ValidUntil/set');
                    return this.input_Passport1ValidUntil = value;

                }, // eo function formatedPassport1ValidUntil set()

            }, // eo function formatedPassport1ValidUntil()


            /******************************************************************* STILL NEEDED CHANGES HERE!!!!
			* formatedPassport2ValidUntil{}
			*
			* Desc:
			* Note:
			*
			*/
            formatedPassport2ValidUntil: {

                get() {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_Passport2ValidUntil/get');
                    return this.input_Passport2ValidUntil ? this.formatDateForTextField(this.input_Passport2ValidUntil) : '';

                }, // eo function input_Passport2ValidUntil get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_Passport2ValidUntil/set');
                    return this.input_Passport2ValidUntil = value;

                }, // eo function input_Passport2ValidUntil set()

            }, // eo function formatedPassport2ValidUntil()


			/*******************************************************************
			* formattedContractStartsFrom{}
			*
			* Desc:
			* Note:
			*
			*/
            formattedContractStartsFrom: {

                get() {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_ContractStartsFrom/get');
                    return this.input_ContractStartsFrom ? this.formatDateForTextField(this.input_ContractStartsFrom) : '';

                }, // eo function input_ContractStartsFrom get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_ContractStartsFrom/set');
                    return this.input_ContractStartsFrom = value;

                }, // eo function input_ContractStartsFrom set()

            }, // eo function formattedContractStartsFrom()


			/*******************************************************************
			* formattedContractEndsOn{}
			*
			* Desc:
			* Note:
			*
			*/
            formattedContractEndsOn: {

                get() {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_ContractEndsOn/get');
                    return this.input_ContractEndsOn ? this.formatDateForTextField(this.input_ContractEndsOn) : '';

                }, // eo function input_ContractEndsOn get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_ContractEndsOn/set');
                    return this.input_ContractEndsOn = value;

                }, // eo function input_ContractEndsOn set()

            }, // eo function formattedContractEndsOn()


			/*******************************************************************
			* formattedExperiencedSince{}
			*
			* Desc:
			* Note:
			*
			*/
            formattedExperiencedSince: {

                get() {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_ExperiencedSince/get');
                    return this.input_ExperiencedSince ? this.formatDateForTextField(this.input_ExperiencedSince) : '';

                }, // eo function input_ExperiencedSince get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_ExperiencedSince/set');
                    return this.input_ExperiencedSince = value;

                }, // eo function input_ExperiencedSince set()

            }, // eo function formattedExperiencedSince()


			/*******************************************************************
			* formattedBasehistorySince{}
			*
			* Desc:
			* Note:
			*
			*/
            formattedBasehistorySince: {

                get() {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_BasehistorySince/get');
                    return this.input_BasehistorySince ? this.formatDateForTextField(this.input_BasehistorySince) : '';

                }, // eo function input_BasehistorySince get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/input_BasehistorySince/set');
                    return this.input_BasehistorySince = value;

                }, // eo function input_BasehistorySince set()

            }, // eo function formattedBasehistorySince()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
			* input_Function()
			*
			* Desc: input_Function corresponds with input_CockpitOrCabin.
			* Note: If input_Function is Captain or First Officer, the
            * Note: department is Cockpit (12).
            * Note: If input_Function is Cabin Attendant or SCCM, the
            * Note: department is Cabin (11).
			*
			*/
            input_Function: function(val) {

                const me = this;

                switch(val) {
                    case 'CP':
                    case 'FO':
                        me.input_CockpitOrCabin = '12';
                        break;
                    case 'SCCM':
                    case 'CA':
                        me.input_CockpitOrCabin = '11';
                        break;
                    default:
                        //won't do anything
                        break;
                }

            },

			/*******************************************************************
			* birthdateMenu()
			*
			* Desc:
			* Note:
			*
			*/
            birthdateMenu: function (val) {

                val && setTimeout(() => (this.$refs.picker_Birthdate.activePicker = 'YEAR'));

            }, // eo function birthdateMenu()


            /*******************************************************************
			* passport1ValidUntilMenu()
			*
			* Desc:
			* Note:
			*
			*/
            passport1ValidUntilMenu: function (val) {

                val && setTimeout(() => (this.$refs.picker_Passport1ValidUntil.activePicker = 'YEAR'));

            }, // eo function passport1ValidUntilMenu()


            /*******************************************************************
			* passport2ValidUntilMenu()
			*
			* Desc:
			* Note:
			*
			*/
            passport2ValidUntilMenu: function (val) {

                val && setTimeout(() => (this.$refs.picker_Passport2ValidUntil.activePicker = 'YEAR'));

            }, // eo function passport2ValidUntilMenu()


            /*******************************************************************
			* contractStartsFromMenu()
			*
			* Desc:
			* Note:
			*
			*/
            contractStartsFromMenu: function (val) {

                val && setTimeout(() => (this.$refs.picker_ContractStartsFrom.activePicker = 'YEAR'));

            }, // eo function contractStartsFromMenu()


            /*******************************************************************
			* contractEndsOnMenu()
			*
			* Desc:
			* Note:
			*
			*/
            contractEndsOnMenu: function (val) {

                val && setTimeout(() => (this.$refs.picker_ContractEndsOn.activePicker = 'YEAR'));

            }, // eo function contractEndsOnMenu()


            /*******************************************************************
			* experiencedSinceMenu()
			*
			* Desc:
			* Note:
			*
			*/
            experiencedSinceMenu: function (val) {

                val && setTimeout(() => (this.$refs.picker_ExperiencedSince.activePicker = 'YEAR'));

            }, // eo function experiencedSinceMenu()


            /*******************************************************************
			* basehistorySinceMenu()
			*
			* Desc:
			* Note:
			*
			*/
            basehistorySinceMenu: function (val) {

                val && setTimeout(() => (this.$refs.picker_BasehistorySince.activePicker = 'YEAR'));

            }, // eo function basehistorySinceMenu()

        }, // eof watch{}
        /* <<< ****************************************************************/




		/* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/people/components/core/BottomSheet.vue >>> created');
            eventBus.$on('resourceswasupdatedcreated', this.onClick_CloseSheet);

		}, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;

            me.$toc('>>> views/people/components/core/BottomSheet.vue >>> destroyed');
            eventBus.$off('resourceswasupdatedcreated', this.onClick_CloseSheet);

		}, // eo function destroyed()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Methods */
		methods: {

            ...mapActions([
                'actn_call_updateCreateResource',
                'actn_call_updateCreateBaseHistory',
                'actn_call_deleteBaseHistory'
            ]),



            /*******************************************************************
            * validateFormStepper()
            *
            * Desc: Validate a single Steppers inputs.
            * Note: Get all children of a Stepper with a ref.
            * Note: Loop over the children and identify them as input fields,
            * Note: after that check for the VALID key.
            *
            * @param {Number} stepperNumber
            * @returns {Boolean}
            */
            validateFormStepper: function(stepperNumber) {

                let stepperIsValid = true,
                    child = null,
                    childInputIsValid = null,
                    stepperRef = null;


                switch (stepperNumber) {
                    case "1":
                        stepperRef = this.$refs.stepperContent1;
                        break;
                    case "2":
                        stepperRef = this.$refs.stepperContent2;
                        break;
                    case "3":
                        stepperRef = this.$refs.stepperContent3;
                        break;
                    case "4":
                        stepperRef = this.$refs.stepperContent4;
                        break;
                    case "5":
                        stepperRef = this.$refs.stepperContent5;
                        break;
                    default:
                        stepperRef = null;
                        break;
                }


                if(stepperRef !== null) {
                    for(let i = 0; i < stepperRef.$children.length; i++) {
                        child = stepperRef.$children[i];

                        childInputIsValid = this.findInputField(child);

                        if(childInputIsValid.valid === false) {
                            stepperIsValid = false;
                            break;
                        }
                    }
                }


                switch (stepperNumber) {
                    case "1":
                        this.isValid_Stepper1 = stepperIsValid;
                        break;
                    case "2":
                        this.isValid_Stepper2 = stepperIsValid;
                        break;
                    case "3":
                        this.isValid_Stepper3 = stepperIsValid;
                        break;
                    case "4":
                        this.isValid_Stepper4 = stepperIsValid;
                        break;
                    case "5":
                        this.isValid_Stepper5 = stepperIsValid;
                        break;
                    default:
                        break;
                }


                return stepperIsValid;

            }, // eo function validateFormStepper()


            /*******************************************************************
            * findInputField()
            *
            * Desc: Identify an element as INPUT.
            * Note: Check ELEMENT of being an input field.
            * Note: It is an input field if the key "type" exists in this
            * Note: object. ('type' in element)
            * Note: If this object does not have this "type" key, look up
            * Note: the children of this ELEMENT recursivly.
            *
            * @param {Object} element
            * @returns {Object | null}
            */
            findInputField: function(element) {

                let inputField = null;


                if('type' in element) { // ;-)
                    inputField = element;
                } else {
                    if(element.$children.length > 0) {
                        inputField = this.findInputField(element.$children[0])
                    }
                }


                return inputField;

            }, // eo function findInputField()




            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
             /*******************************************************************
            * onValidate_Form()
            *
            * Desc: Check if Form is valid.
            * Note: used in 'update' and 'create' Mode.
            * Note: Sends 'id' in 'update' Mode...And NO 'id' in 'create' Mode.
            *
            */
            onValidate_Form: function() {

                const me = this;
                let payload = null;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onValidate_Form');
                me.validateFormStepper("1");
                me.validateFormStepper("2");
                me.validateFormStepper("3");
                me.validateFormStepper("4");
                me.validateFormStepper("5");

                if (this.$refs.form.validate() === true) {
                    payload = {
                        'id': this.editorMode === 'create' ? null : +this.input_ResourceId, // Important: Watch this!
                        'idHrDepartment': this.editorMode === 'update' ? +this.input_idHrDepartment : +this.input_CockpitOrCabin, // 11: Cabin, 12: Cockpit
                        'encodedImageId': null,
                        'genFirstName': this.input_FirstName,
                        'genLastname': this.input_LastName,
                        'genBirthdate': this.formatDateForBackend(this.input_Birthdate),
                        'genGender': this.input_Gender,
                        'genMaritalStatus': this.input_MaritalStatus,
                        'genIdCountry': (this.input_Nationality !== null && this.input_Nationality !== '') ? +this.input_Nationality : null,
                        'genChildren': (this.input_NoOfChildren !== null && this.input_NoOfChildren !== '') ? +this.input_NoOfChildren : null,
                        'genChildrenSchool': (this.input_NoOfChildrenInSchool !== null && this.input_NoOfChildrenInSchool !== '') ? +this.input_NoOfChildrenInSchool : null,
                        'genFlyingOffice': this.input_FlyingOrOffice,
                        'genEyesColor': this.input_EyeColor,
                        'genOverall': (this.input_Overall !== null && this.input_Overall !== '' && this.input_Overall !== '0') ? +this.input_Overall : null,
                        'genPassportNumber': this.input_Passport1No,
                        'genPassportNumberTwo': this.input_Passport2No,
                        'genHeight': (this.input_HeightInCm !== null && this.input_HeightInCm !== '' && this.input_HeightInCm !== '0') ? +this.input_HeightInCm : null,
                        'genShoesize': (this.input_Shoesize !== null && this.input_Shoesize !== '' && this.input_Shoesize !== '0') ? +this.input_Shoesize : null,
                        'genSpokenLangueges': this.input_Languages.length !== 0 ? this.input_Languages : null,
                        'genPassportExpires': this.formatDateForBackend(this.input_Passport1ValidUntil),
                        'genPassportExpiresTwo': this.formatDateForBackend(this.input_Passport2ValidUntil),
                        'genRemark': this.input_Remark,
                        'addressIdCountry': (this.input_Country !== null && this.input_Country !== '') ? +this.input_Country : null,
                        'addressCity': this.input_City,
                        'addressStreet': this.input_Street,
                        'addressZip': this.input_ZIP,
                        'addressHousenumber': this.input_SteetNo,
                        'comPhone1': this.input_Phone1,
                        'comEmail': this.input_Email,
                        'comPhone2': this.input_Phone2,
                        'contract3Code': this.input_3LetterCode,
                        'contractFunction': this.input_Function,
                        'contractStarts': this.formatDateForBackend(this.input_ContractStartsFrom),
                        'contractOffDays': (this.input_OffdaysPerYear !== null && this.input_OffdaysPerYear !== '') ? +this.input_OffdaysPerYear : null,
                        'contractRadiation': (this.input_RadiationValue !== null && this.input_RadiationValue !== '') ? +this.input_RadiationValue : null,
                        'contractVacationDays': (this.input_VacationDays !== null && this.input_VacationDays !== '') ? +this.input_VacationDays : null,
                        'crewIds': this.input_Crews.map(x => x.id),
                        'invoiceOrder': (this.input_invoiceOrder !== null && this.input_invoiceOrder !== '') ? +this.input_invoiceOrder : null,
                        'contractBaseStation': this.input_Base !== null ? +this.input_Base : null,
                        'contractAddFunction': this.input_AdditionalFunction,
                        'contractEnds': this.formatDateForBackend(this.input_ContractEndsOn),
                        'contractOffDaysMonth': (this.input_OffdaysPerMonth !== null && this.input_OffdaysPerMonth !== '') ? +this.input_OffdaysPerMonth : null,
                        'contractIdAircraft': (this.input_Aircraft !== null && this.input_Aircraft !== '') ? +this.input_Aircraft : null,
                        'drivingLicense': this.input_DrivingLicenseB === 'true' ? true : false,
                        'freelance': this.input_Freelancer === 'true' ? true : false,
                        'experienced': this.input_Experienced === 'true' ? true : false,
                        'experiencedFrom': this.formatDateForBackend(this.input_ExperiencedSince),
                        'active': this.input_Active === 'true' ? true : false,
                        'emergencyContacts': [
                            {
                                'name': this.input_LastNameEmergContact1,
                                'email': this.input_EmailEmergContact1,
                                'firstName': this.input_FirstNameEmergContact1,
                                'phone': this.input_PhoneEmergContact1,
                                'relationship': this.input_RelationEmergContact1
                            },
                            {
                                'name': this.input_LastNameEmergContact2,
                                'email': this.input_EmailEmergContact2,
                                'firstName': this.input_FirstNameEmergContact2,
                                'phone': this.input_PhoneEmergContact2,
                                'relationship': this.input_RelationEmergContact2
                            },
                        ],
                        'baseHistory': this.editorMode === "create" ? this.build_buildBaseHistoryObjectForCreate() : null
                    };

                    this.actn_call_updateCreateResource({ payload: payload, editorMode: this.editorMode });
                }

            }, // eof onValidate_Form()


            /*******************************************************************
            * build_buildBaseHistoryObjectForCreate()
            *
            * Desc: Create a Base History Object for creating or updating a
            * Desc: resource.
            * Note: On Create: Send an Object with the form (see below) to add
            * Note: an initial Base History Entry.
            * Note: On Update: Send null, nothing happens.
            *
            * @returns {Object} { id, idBase, sinceDate }
            */
            build_buildBaseHistoryObjectForCreate: function() {

                let me = this,
                    baseHistoryObject = null;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> build_buildBaseHistoryObjectForCreate');
                if(this.input_Base !== null) {
                    baseHistoryObject = {
                        id: null,
                        idBase: this.input_Base,
                        sinceDate: this.formatDateForBackend(dayjs())
                    }
                }


                return baseHistoryObject;

            }, // eof build_buildBaseHistoryObjectForCreate()


            /*******************************************************************
            * onValidate_BaseHistory()
            *
            * Desc: Check if baseHistory Form is valid.
            * Note: Used in 'update' and 'create' Mode.
            * Note: Sends 'id' in 'update' Mode...And NO 'id' in 'create' Mode.
            *
            */
            onValidate_BaseHistory: function() {

                const me = this;
                let payload = null;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onValidate_BaseHistory');
                //TODO: Create a form for base history,
                //problems: if we use rules for base airport or base since we check them
                //on onValide_Form too and it would produce an error
                //second problem: we can not simply check two single input fields
                //third problem: if we can check them the error would not be shown (somehow...)

                payload = {
                    id: null,
                    idBase: this.input_BaseHistoryAirport,
                    idResource: this.input_ResourceId,
                    sinceDate: this.formatDateForBackend(this.input_BasehistorySince)
                };

                this.actn_call_updateCreateBaseHistory(payload);

            }, //eof onValidate_BaseHistory()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_CloseSheet()
            *
            * Desc:
            * Note:
            *
            */
			onClick_CloseSheet: function() {

                const me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_CloseSheet');
				this.sheetShown = false;

            }, // eo function onClick_CloseSheet()


            /*******************************************************************
            * onClick_DeleteBasehistoryEntry()
            *
            * Desc:
            * Note:
            *
            */
			onClick_DeleteBasehistoryEntry: function(itemToDelete) {

                const me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_DeleteBasehistoryEntry');
                me.showConfirmDeleteDialog = true;
                me.baseHistoryObjectToDelete = itemToDelete;

            }, // eo function onClick_DeleteBasehistoryEntry()



            /*******************************************************************
            * onClick_CloseDelete()
            *
            * Desc:
            * Note:
            *
            */
			onClick_CloseDelete: function() {

                const me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_CloseDelete');
                me.showConfirmDeleteDialog = false;

            }, // eo function onClick_CloseDelete()



            /*******************************************************************
            * onClick_DeleteItemConfirm()
            *
            * Desc:
            * Note:
            *
            */
			onClick_DeleteItemConfirm: function() {

                const me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_DeleteItemConfirm');
                me.showConfirmDeleteDialog = false;
                me.actn_call_deleteBaseHistory(me.baseHistoryObjectToDelete);

            }, // eo function onClick_DeleteItemConfirm()



			/******************************************************************* 'Listeners - DatePickers'
			* onChange_SaveBirthdate()
			*
			* Desc:
            * Note:
            *
            * @param {Object} date ()
			*/
			onChange_SaveBirthdate: function(date) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onChange_SaveBirthdate');
                this.$refs.birthdateMenu.save(date);

            }, // eo function onChange_SaveBirthdate()


            /*******************************************************************
			* onChange_SavePassport1ValidUntil()
			*
			* Desc:
            * Note:
            *
            * @param {Object} date ()
			*/
			onChange_SavePassport1ValidUntil: function(date) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onChange_SavePassport1ValidUntil');
                this.$refs.passport1ValidUntilMenu.save(date);

            }, // eo function onChange_SavePassport1ValidUntil()


            /*******************************************************************
			* onChange_SavePassport2ValidUntil()
			*
			* Desc:
            * Note:
            *
            * @param {Object} date ()
			*/
			onChange_SavePassport2ValidUntil: function(date) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onChange_SavePassport2ValidUntil');
                this.$refs.passport2ValidUntilMenu.save(date);

            }, // eo function onChange_SavePassport2ValidUntil()


            /*******************************************************************
			* onChange_SaveContractStartsFrom()
			*
			* Desc:
            * Note:
            *
            * @param {Object} date ()
			*/
			onChange_SaveContractStartsFrom: function(date) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onChange_SaveContractStartsFrom');
                this.$refs.contractStartsFromMenu.save(date);

            }, // eo function onChange_SaveContractStartsFrom()


            /*******************************************************************
			* onChange_SaveContractEndsOn()
			*
			* Desc:
            * Note:
            *
            * @param {Object} date ()
			*/
			onChange_SaveContractEndsOn: function(date) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onChange_SaveContractEndsOn');
                this.$refs.contractEndsOnMenu.save(date);

            }, // eo function onChange_SaveContractEndsOn()


            /*******************************************************************
			* onChange_SaveExperiencedSince()
			*
			* Desc:
            * Note:
            *
            * @param {Object} date ()
			*/
			onChange_SaveExperiencedSince: function(date) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onChange_SaveExperiencedSince');
                this.$refs.experiencedSinceMenu.save(date);

            }, // eo function onChange_SaveExperiencedSince()


            /*******************************************************************
			* onChange_SaveBasehistorySince()
			*
			* Desc:
            * Note:
            *
            * @param {Object} date ()
			*/
			onChange_SaveBasehistorySince: function(date) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onChange_SaveBasehistorySince');
                this.$refs.basehistorySinceMenu.save(date);

            }, // eo function onChange_SaveBasehistorySince()


            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc: Validate leaved Stepper Content, set new active Stepper.
            * Note: First validate the activeStepper, but only if it was
            * Note: validated as FALSE before.
            *
            */
            onClick_StepperHeader: function(stepperNumber) {

                const me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_StepperHeader');
                switch (me.activeStepper) {
                    case '1':
                        if (me.isValid_Stepper1 === false) {
                            me.validateFormStepper('1');
                        }
                        break;
                    case '2':
                        if (me.isValid_Stepper2 === false) {
                            me.validateFormStepper('2');
                        }
                        break;
                    case '3':
                        if (me.isValid_Stepper3 === false) {
                            me.validateFormStepper('3');
                        }
                        break;
                    case '4':
                        if (me.isValid_Stepper4 === false) {
                            me.validateFormStepper('4');
                        }
                        break;
                    case '5':
                        if (me.isValid_Stepper5 === false) {
                            me.validateFormStepper('5');
                        }
                        break;
                    default: break;
                }

                me.activeStepper = stepperNumber;

            },




            /*******************************************************************
            * Utilities/Helper:
            *******************************************************************/
            /******************************************************************* 'Assign -  Update/Create'
            * onAssign_Update()
            *
            * Desc: Assign Object in/for 'update' Mode.
            * Note:
            *
            * @param {Object} eventRecord ()
            */
            onAssign_Update: function(eventRecord) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onAssign_Update');
                Object.assign(me, {
                    // >>> General ------------------------
                    input_ResourceId: eventRecord.id,
                    input_idHrDepartment: eventRecord.idHrDepartment,
                    input_FirstName: eventRecord.genFirstName,
                    input_LastName: eventRecord.genLastname,
                    input_Birthdate: this.formatDateForDatePicker(eventRecord.genBirthdate),
                    input_Gender: eventRecord.genGender,
                    input_MaritalStatus: eventRecord.genMaritalStatus,
                    input_Nationality: eventRecord.genIdCountry,
                    input_NoOfChildren: eventRecord.genChildren !== null ? String(eventRecord.genChildren) : '',
                    input_NoOfChildrenInSchool: eventRecord.genChildrenSchool !== null ? String(eventRecord.genChildrenSchool) : '',
                    input_FlyingOrOffice: eventRecord.genFlyingOffice,
                    input_EyeColor: eventRecord.genEyesColor,
                    input_HeightInCm: eventRecord.genHeight !== null ? String(eventRecord.genHeight) : '',
                    input_Shoesize: eventRecord.genShoesize !== null ? String(eventRecord.genShoesize) : '',
                    input_Overall: eventRecord.genOverall !== null ? String(eventRecord.genOverall) : '',
                    input_Languages: eventRecord.genSpokenLangueges !== null ? eventRecord.genSpokenLangueges : '',
                    input_Passport1No: eventRecord.genPassportNumber,
                    input_Passport1ValidUntil: this.formatDateForDatePicker(eventRecord.genPassportExpires),
                    input_Passport2No: eventRecord.genPassportNumberTwo,
                    input_Passport2ValidUntil: eventRecord.genPassportExpiresTwo,
                    input_Remark: eventRecord.genRemark,
                    // >>> ------------------------------------ 'Contact'
                    input_City: eventRecord.addressCity,
                    input_ZIP: eventRecord.addressZip,
                    input_Country: eventRecord.addressIdCountry,
                    input_Street: eventRecord.addressStreet,
                    input_SteetNo: eventRecord.addressHousenumber,
                    input_Phone1: eventRecord.comPhone1,
                    input_Phone2: eventRecord.comPhone2,
                    input_Email: eventRecord.comEmail,
                    // >>> ------------------------------------ 'Emergency Contact'
                    input_FirstNameEmergContact1: eventRecord.emergencyContacts[0] !== undefined ? eventRecord.emergencyContacts[0].firstName : null,
                    input_LastNameEmergContact1: eventRecord.emergencyContacts[0] !== undefined ? eventRecord.emergencyContacts[0].name : null,
                    input_PhoneEmergContact1: eventRecord.emergencyContacts[0] !== undefined ? eventRecord.emergencyContacts[0].phone : null,
                    input_EmailEmergContact1: eventRecord.emergencyContacts[0] !== undefined ? eventRecord.emergencyContacts[0].email : null,
                    input_RelationEmergContact1: eventRecord.emergencyContacts[0] !== undefined ? eventRecord.emergencyContacts[0].relationship : null,
                    input_FirstNameEmergContact2: eventRecord.emergencyContacts[1] !== undefined ? eventRecord.emergencyContacts[1].firstName : null,
                    input_LastNameEmergContact2: eventRecord.emergencyContacts[1] !== undefined ? eventRecord.emergencyContacts[1].name : null,
                    input_PhoneEmergContact2: eventRecord.emergencyContacts[1] !== undefined ? eventRecord.emergencyContacts[1].phone : null,
                    input_EmailEmergContact2: eventRecord.emergencyContacts[1] !== undefined ? eventRecord.emergencyContacts[1].email : null,
                    input_RelationEmergContact2: eventRecord.emergencyContacts[1] !== undefined ? eventRecord.emergencyContacts[1].relationship : null,
                    // >>> ------------------------------------ 'Contract Infos'
                    input_3LetterCode: eventRecord.contract3Code,
                    input_invoiceOrder: String(eventRecord.invoiceOrder),
                    input_Function: eventRecord.contractFunction,
                    input_AdditionalFunction: eventRecord.contractAddFunction,
                    input_Base: eventRecord.contractBaseStation,
                    input_Aircraft: eventRecord.contractIdAircraft,
                    input_CockpitOrCabin: eventRecord.idHrDepartment !== null ? String(eventRecord.idHrDepartment) : '',
                    input_Crews: this.get_people_crewsOnAirplane.filter(x => eventRecord.crewIds.includes(x.id)),
                    input_ContractStartsFrom: this.formatDateForDatePicker(eventRecord.contractStarts),
                    input_ContractEndsOn: this.formatDateForDatePicker(eventRecord.contractEnds),
                    input_VacationDays: eventRecord.contractVacationDays !== null ? String(eventRecord.contractVacationDays) : '',
                    input_OffdaysPerYear: eventRecord.contractOffDays !== null ? String(eventRecord.contractOffDays) : '',
                    input_OffdaysPerMonth: eventRecord.contractOffDaysMonth !== null ? String(eventRecord.contractOffDaysMonth) : '',
                    input_RadiationValue: eventRecord.contractRadiation !== null ? String(eventRecord.contractRadiation) : '',
                    // >>> ------------------------------------ 'Documentation'
                    input_Experienced: String(eventRecord.experienced),
                    input_ExperiencedSince: this.formatDateForDatePicker(eventRecord.experiencedFrom),
                    input_DrivingLicenseB: String(eventRecord.drivingLicense),
                    input_Freelancer: String(eventRecord.freelance),
                    input_Active: String(eventRecord.active),
                    // >>> ------------------------------------ 'Base History'
                    input_contractBaseStationHistory: eventRecord.contractBaseStationHistory !== null ? eventRecord.contractBaseStationHistory : [],
                    input_BasehistorySince: dayjs().format('YYYY-MM-DD'),
                    input_BaseHistoryAirport: null,
                    // >>> ------------------------------------ 'Stepper Errors'
                    isValid_Stepper1: true,
                    isValid_Stepper2: true,
                    isValid_Stepper3: true,
                    isValid_Stepper4: true,
                    isValid_Stepper5: true,
                    activeStepper: '1',
                    // >>> ------------------------------------ 'Resource Name'
                    actualResourceName: eventRecord.fullName
                });

            }, // eof onAssign_Update()


            /*******************************************************************
            * onAssign_Create()
            *
            * Desc: Assign Object in/for 'create' Mode. (Reset)
            * Note:
            *
            */
            onAssign_Create: function() {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onAssign_Create');
                Object.assign(me, {
                    // >>> General ------------------------
                    input_ResourceId: null,
                    input_idHrDepartment: null,
                    input_FirstName: '',
                    input_LastName: '',
                    input_Birthdate: '',
                    input_Gender: null,
                    input_MaritalStatus: null,
                    input_Nationality: 70,
                    input_NoOfChildren: '',
                    input_NoOfChildrenInSchool: '',
                    input_FlyingOrOffice: null,
                    input_EyeColor: null,
                    input_HeightInCm: '',
                    input_Shoesize: '',
                    input_Overall: '',
                    input_Languages: '',
                    input_Passport1No: '',
                    input_Passport1ValidUntil: '',
                    input_Passport2No: '',
                    input_Passport2ValidUntil: '',
                    input_Remark: '',
                    // >>> ------------------------------------ 'Contact'
                    input_City: '',
                    input_ZIP: '',
                    input_Country: 70,
                    input_Street: '',
                    input_SteetNo: '',
                    input_Phone1: '',
                    input_Phone2: '',
                    input_Email: '',
                    // >>> ------------------------------------ 'Emergency Contact'
                    input_FirstNameEmergContact1: '',
                    input_LastNameEmergContact1: '',
                    input_PhoneEmergContact1: '',
                    input_EmailEmergContact1: '',
                    input_RelationEmergContact1: '',
                    input_FirstNameEmergContact2: '',
                    input_LastNameEmergContact2: '',
                    input_PhoneEmergContact2: '',
                    input_EmailEmergContact2: '',
                    input_RelationEmergContact2: '',
                    // >>> ------------------------------------ 'Contract Infos'
                    input_3LetterCode: '',
                    input_invoiceOrder: '',
                    input_Function: null,
                    input_AdditionalFunction: null,
                    input_Base: null,
                    input_Aircraft: null,
                    input_CockpitOrCabin: null,
                    input_Crews: [],
                    input_ContractStartsFrom: '',
                    input_ContractEndsOn: '',
                    input_VacationDays: '',
                    input_OffdaysPerYear: '',
                    input_OffdaysPerMonth: '',
                    input_RadiationValue: '',
                    // >>> ------------------------------------- 'Documentation'
                    input_Experienced: 'true',
                    input_ExperiencedSince: '',
                    input_DrivingLicenseB: 'true',
                    input_Freelancer: 'false',
                    input_Active: 'true',
                    // >>> -------------------------------------- 'Base History'
                    input_contractBaseStationHistory: [],
                    input_BasehistorySince: dayjs().format('YYYY-MM-DD'),
                    input_BaseHistoryAirport: null,
                    // >>> ------------------------------------ 'Stepper Errors'
                    isValid_Stepper1: true,
                    isValid_Stepper2: true,
                    isValid_Stepper3: true,
                    isValid_Stepper4: true,
                    isValid_Stepper5: true,
                    activeStepper: '1',
                    // >>> ------------------------------------ 'Resource Name'
                    actualResourceName: ''
                });

            }, // eof onAssign_Create()


            /*******************************************************************
            * validateFormStepper()
            *
            * Desc: Create Display Name for Crew with Format
            * Desc: "Crew name - Aircraft Name"
            * Note:
            *
            * @param {Number} stepperNumber
            * @returns {Boolean}
            */
            createNameForInputCrews: function(item) {

                let name = "",
                    aircraft = "";


                aircraft = this.get_AircraftConfigs.find(x => x.id === item.idAircraft);
                if(aircraft === undefined) {
                    name = item.name;
                }
                if(aircraft !== undefined) {
                    name = item.name + ' - ' + aircraft.code;
                }


                return name;

            }, // eo function createNameForInputCrews


            /******************************************************************* 'Format - Dates'
            * formatDateForDatePicker()
            *
            * Desc: Modify the date (ISO) to Date Picker Format.
            * Note: Date Picker Format: YYYY-MM-DD
            *
            * @param {Object} date ()
            */
            formatDateForDatePicker: function(date) {

                const me = this;
                let formattedDate = null;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> formatDateForDatePicker');
                if (date !== null) {
                    formattedDate = dayjs(date).format('YYYY-MM-DD');
                }


                return formattedDate;

            }, // eo function formatDateForDatePicker()


            /*******************************************************************
            * formatDateForTextField()
            *
            * Desc: Modify the date with the utc filter.
            *
            * @param {Object} date ()
            */
            formatDateForTextField: function(date) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> formatDateForTextField');
                return me.$options.filters.dayjsUtcDe(date);

            }, // eo function formatDateForTextField()


            /*******************************************************************
            * formatDateForBackend()
            *
            * Desc: Modify the date for the backend calls.
            * Note: Format YYYY-MM-DD[T]01:00:00[Z]
            *
            * @param {Object} date ()
            */
            formatDateForBackend: function(date) {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> formatDateForBackend');
                return me.$options.filters.dayjsISOFormat(date);

            }, // eo function formatDateForBackend()



            /******************************************************************* 'Min/Max - Date Fields'
            * get_MaxDate_Birthdate()
            *
            * Desc:
            *
            */
            get_MaxDate_Birthdate: function() {

                return dayjs().format('YYYY-MM-DD');

            }, // eo function get_MaxDate_Birthdate()

            /*******************************************************************
            * get_MinDate_Birthdate()
            *
            * Desc:
            *
            */
            get_MinDate_Birthdate: function() {

                return dayjs().subtract(70, 'years').startOf('year').format('YYYY-MM-DD');

            }, // eo function get_MinDate_Birthdate()


            /*******************************************************************
            * get_MaxDate_Passport1ValidUntil()
            *
            * Desc:
            *
            */
            get_MaxDate_Passport1ValidUntil: function() {

                return dayjs().add(10, 'years').endOf('year').format('YYYY-MM-DD');

            }, // eo function get_MaxDate_Passport1ValidUntil()

            /*******************************************************************
            * get_MinDate_Passport1ValidUntil()
            *
            * Desc:
            *
            */
            get_MinDate_Passport1ValidUntil: function() {

                return dayjs().format('YYYY-MM-DD');

            }, // eo function get_MinDate_Passport1ValidUntil()


            /*******************************************************************
            * get_MaxDate_Passport2ValidUntil()
            *
            * Desc:
            *
            */
            get_MaxDate_Passport2ValidUntil: function() {

                return dayjs().add(10, 'years').endOf('year').format('YYYY-MM-DD');

            }, // eo function get_MaxDate_Passport2ValidUntil()

            /*******************************************************************
            * get_MinDate_Passport2ValidUntil()
            *
            * Desc:
            *
            */
            get_MinDate_Passport2ValidUntil: function() {

                return dayjs().format('YYYY-MM-DD');

            }, // eo function get_MinDate_Passport2ValidUntil()


            /*******************************************************************
            * get_MaxDate_ContractStartsFrom()
            *
            * Desc:
            *
            */
            get_MaxDate_ContractStartsFrom: function() {

                return dayjs().add(1, 'years').endOf('year').format('YYYY-MM-DD');

            }, // eo function get_MaxDate_ContractStartsFrom()

            /*******************************************************************
            * get_MinDate_ContractStartsFrom()
            *
            * Desc:
            *
            */
            get_MinDate_ContractStartsFrom: function() {

                return dayjs().subtract(1, 'years').startOf('year').format('YYYY-MM-DD');

            }, // eo function get_MinDate_ContractStartsFrom()


            /*******************************************************************
            * get_MaxDate_ContractEndsOn()
            *
            * Desc:
            *
            */
            get_MaxDate_ContractEndsOn: function() {

                return dayjs().add(80, 'years').endOf('year').format('YYYY-MM-DD');

            }, // eo function get_MaxDate_ContractEndsOn()

            /*******************************************************************
            * get_MinDate_ContractEndsOn()
            *
            * Desc:
            *
            */
            get_MinDate_ContractEndsOn: function() {

                return dayjs().subtract(1, 'years').startOf('year').format('YYYY-MM-DD');

            }, // eo function get_MinDate_ContractEndsOn()


            /*******************************************************************
            * get_MaxDate_ExperiencedSince()
            *
            * Desc:
            *
            */
            get_MaxDate_ExperiencedSince: function() {

                return dayjs().format('YYYY-MM-DD');

            }, // eo function get_MaxDate_ExperiencedSince()

            /*******************************************************************
            * get_MinDate_ExperiencedSince()
            *
            * Desc:
            *
            */
            get_MinDate_ExperiencedSince: function() {

                return dayjs().subtract(70, 'years').startOf('year').format('YYYY-MM-DD');

            }, // eo function get_MinDate_ExperiencedSince()


            /*******************************************************************
            * get_MaxDate_BasehistorySince()
            *
            * Desc:
            *
            */
            get_MaxDate_BasehistorySince: function() {

                return dayjs().add(10, 'years').format('YYYY-MM-DD');

            }, // eo function get_MaxDate_BasehistorySince()

            /*******************************************************************
            * get_MinDate_BasehistorySince()
            *
            * Desc:
            *
            */
            get_MinDate_BasehistorySince: function() {

                return dayjs().subtract(2, 'years').format('YYYY-MM-DD');

            } // eo function get_MinDate_BasehistorySince()

        } // eo methods{}

    };
</script>

<style scoped>
    .v-dialog > .v-card > .v-card__actions {
        padding: 10px 10px;
    }

    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        max-height:700px;
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }



</style>

<style>
    .v-input__icon--append .v-icon {
        color: #ab3b7a;
    }

    .theme--light.v-label {
        color: rgba(0, 0, 0, 1);
    }
</style>
